import { render, staticRenderFns } from "./PageICI.vue?vue&type=template&id=a93d3ff0&scoped=true"
import script from "./PageICI.vue?vue&type=script&lang=js"
export * from "./PageICI.vue?vue&type=script&lang=js"
import style0 from "./PageICI.vue?vue&type=style&index=0&id=a93d3ff0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a93d3ff0",
  null
  
)

export default component.exports